import "./App.css";
import Navbar from "./components/Navbar.jsx";
// import HomePage from "./components/HomePage.jsx";
import About from "./components/About.jsx";
import Skills from "./components/Skills.jsx";
import Work from "./components/Work.jsx";
import GLM from "./components/GLM.jsx";
import Contact from "./components/Contact.jsx";
import ChatBox from "./components/ChatBox.jsx";
import { useCallback, useEffect, useState } from "react";
import Experience from "./components/Experience.jsx";
import GithubState from "./components/GithubState.jsx";
import Home from "./components/Home.jsx";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  useEffect(() => {
    localStorage.setItem("theme", isDarkMode ? "dark" : "");
  }, [isDarkMode]);

  const toggleTheme = useCallback(() => {
    setIsDarkMode(!isDarkMode);
  }, [isDarkMode]);
  return (
    <div className={`${isDarkMode ? "dark" : ""}`}>
      <Navbar isDarkMode={isDarkMode} toggleTheme={toggleTheme} />

      {/* <HomePage /> */}
      <Home />
      <About />
      <Skills />
      <Experience />
      <GithubState />
      <Work />
      <div className="fixed vs:bottom-4 ts:bottom-8 vs:right-10 ts:left-8 w-min">
        <GLM />
      </div>
      <Contact />
      <div className="z-50 fixed vs:ml-5 ts:ml-0 bottom-0 ts:right-10 w-min">
        <ChatBox />
      </div>
    </div>
  );
}

export default App;
